// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyAs9GajnyakFzxKfoLF4gKQV3XykTKol0o",
    authDomain: "spicy-onion.firebaseapp.com",
    projectId: "spicy-onion",
    storageBucket: "spicy-onion.appspot.com",
    messagingSenderId: "801710997645",
    appId: "1:801710997645:web:f1ce285453258f6f0c62c4",
    measurementId: "G-22WZ7RM0J5"
};